import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';

function RelateEntitiesHeader({instructionalText, entityLabel, entityName}) {
	return (
		<StyledRelateEntitiesHeader className="StyledRelateEntitiesHeader">
			<section className="header-instructional-text">{instructionalText}</section>
			<section className="header-entity-label">{entityLabel}</section>
			<section className="header-entity-name">{entityName}</section>
		</StyledRelateEntitiesHeader>
	);
}

RelateEntitiesHeader.propTypes = {
	instructionalText: PropTypes.string,
	entityLabel: PropTypes.string,
	entityName: PropTypes.string
};

const StyledRelateEntitiesHeader = styled.section`
	.header-instructional-text {
		font-size: var(--px-14);
		font-weight: 300;
		color: var(--neutrals-1000);
		margin-bottom: var(--px-20);
		line-height: normal;
	}
	.header-entity-label {
		font-size: var(--px-14);
		font-weight: 300;
		color: var(--neutrals-1000);
		margin-bottom: var(--px-5);
		line-height: normal;
	}
	.header-entity-name {
		font-size: var(--px-16);
		font-weight: 600;
		color: var(--neutrals-900);
		margin-bottom: var(--px-20);
		line-height: normal;
	}
`;

export default RelateEntitiesHeader;
